// import getConfig from 'next/config';
import { structureAddons } from '../../../../util/Format.util';
import { getCookie } from '../../../hooks/useCookie';
import { addPrepayAddOns, getAddOns, removeAddOns } from '../../../integration/addons.api';
import getCarts from '../../../integration/cart.api';
import { addHandset, removeEquipment } from '../../../integration/handset.api';
import { displayCart } from '../../eir-cart/cart.util';
import { mobileHandsetDetailsOnLoad } from '../../eir-mobile-offer-container/mobile.util';
import { SERVICE_GROUPS, CHANNEL, OFFER_TYPE_CODE, ADDON_ITEM_GROUP } from '../../shared/Constants';

const { MOBILE } = SERVICE_GROUPS;
const { ESHOP } = CHANNEL;
const { PREPAY } = OFFER_TYPE_CODE;
const { SUBSCRIPTION } = ADDON_ITEM_GROUP;

// const { publicRuntimeConfig } = getConfig();

/**
 * @function onPageLoad - Onload function on handset details page
 * @param {graphql} graphql - From useApolloClient
 * @param {function} setState - From useApolloClient
 * @param {object} state - Contains local state of the container
 * @param {fucntion} setLoader - Sets the loader to display skeleton
 * @param {function} setOnLoadError - Sets the error onload of the page when API is failed
 * @param {function} setErrorModalOccurence - Sets the error modal occurence
 * @param {string} errorModalOccurence -Error modal occurences
 * @param {function} setOpenError - Function which sets error on API failure
 * @param {function} openAPIFailureModal - Triggers API error modal
 * @returns {object} - Handset details
 */
export const onPageLoad = async ({
  mobileHandsetCode,
  graphql,
  dispatch,
  localStore,
  errorModalOccurence,
  setOnLoadError,
  errorModal,
  openAPIFailureModal,
  setLoading,
  loading,
  setState,
  state,
  setOpenError,
  setErrorModalOccurence,
}) => {
  if (getCookie('STANDALONE_HANDSET')) {
    const { offers, selectedMobileOffer, discounts } = await mobileHandsetDetailsOnLoad({
      graphql,
      localStorage: localStore,
      dispatch,
      mobileHandsetCode,
    });
    if (!offers) {
      setOnLoadError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
    } else {
      setLoading({ ...loading, offerData: true });
      setState({
        ...state,
        offers,
        discounts,
        selectedMobileOffer: selectedMobileOffer?.offer,
      });
      setLoading({ ...loading, offerData: false });
    }
  }
};

/**
 * @function onPageLoadWhenVarientChanges - Onload function on when varaint changes in handset details page
 * @param {graphql} graphql - From useApolloClient
 * @param {function} setState - From useApolloClient
 * @param {object} state - Contains local state of the container
 * @param {fucntion} setLoading - Sets the loader to display skeleton
 * @param {function} mobileHandsetCode - Handset code
 * @param {function} loading - Sets the loading state
 * @param {string} setCoUpgradeButton - Enable co upgrade button
 * @returns {object} - Handset details
 */
export const onPageLoadWhenVarientChanges = async ({
  mobileHandsetCode,
  graphql,
  dispatch,
  setState,
  localStore,
  setCoUpgradeButton,
  setLoading,
  loading,
  state,
}) => {
  const { offers, selectedMobileOffer, discounts } = await mobileHandsetDetailsOnLoad({
    graphql,
    localStorage: localStore,
    dispatch,
    mobileHandsetCode,
  });
  if (offers) {
    setState({
      ...state,
      offers,
      discounts,
      selectedMobileOffer: selectedMobileOffer?.offer,
    });
    if (
      selectedMobileOffer?.offer &&
      getCookie('HANDSET_BE_OFFERID') &&
      getCookie('STANDALONE_HANDSET')
    ) {
      setCoUpgradeButton(true);
    }
    setLoading({ ...loading, offerData: false });
  }
};

/**
 * @name getPrepayAddons - Function for getting prepay addons
 * @description - Function returns array of addons
 */
export const getPrepayAddons = async ({ handsetCode }) => {
  try {
    const variables = {
      offerTypeCode: PREPAY,
      serviceGroupCode: MOBILE,
      channel: ESHOP,
      equipmentCode: handsetCode,
      itemGroup: SUBSCRIPTION,
      // eslint-disable-next-line
      portIn: getCookie('PREPAY_STANDALONE_PORTIN') === 'true' ? true : false,
    };
    const addOnsData = await getAddOns({ variables });
    const result = addOnsData?.map(addon => structureAddons(addon));
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};
/**
 * @name addPrepayAddOn - Function for adding selected addon to the cart
 */
export const addPrepayAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch,
  handsetCode,
  setShowNext,
  router,
  setOnLoadError,
  setErrorModalOccurence,
  errorModal,
  errorModalOccurence,
  openAPIFailureModal,
  setOpenError
) => {
  setShowLoader(catalogCode);
  try {
    let variables = {};

    const offerId = await rootState.cart?.offers?.filter(
      offer => offer?.baseOffer?.serviceGroup === MOBILE
    )[0]?.id;

    variables = {
      reference: getCookie('reference'),
      catalogCode,
      offerId,
      cartType: getCookie('cart_Type'),
    };

    const data = await addPrepayAddOns({ graphql, variables });
    if (data) {
      dispatch({ type: 'SET_CART', payload: data });
      displayCart({
        dispatch,
        nextMethod: null,
      });
      const { addMobileHandset: cartData } = await addHandset({
        graphql,
        variables: {
          prospectUuid: getCookie('reference'),
          catalogCode: handsetCode,
          offerId,
          equipments: rootState?.cart?.offers
            ?.filter(offer => offer.id === offerId)[0]
            ?.equipments?.map(eq => eq.id),
          // eslint-disable-next-line
          portIn: getCookie('PREPAY_STANDALONE_PORTIN') === 'true' ? true : false,
        },
      });
      dispatch({ type: 'SET_CART', payload: cartData });
      setOfferSelected(catalogCode);
      setShowLoader('');
      if (cartData) {
        // router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/prepay/summary`);
        setShowNext(true);
      }
      return { cart: cartData };
    }
  } catch (err) {
    console.error(err);
    setOnLoadError(true);
    setShowLoader(false);
    setOpenError(true);
    setErrorModalOccurence(errorModalOccurence + 1);
    errorModal.enable();
    openAPIFailureModal.enable();
    return err;
  }
};

/**
 * @name removePrepayAddOn - Function for removing selected addon to the cart
 */
export const removePrepayAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch,
  setOnLoadError,
  setErrorModalOccurence,
  errorModal,
  errorModalOccurence,
  openAPIFailureModal,
  setOpenError
) => {
  setShowLoader(catalogCode);
  try {
    const prospect = getCookie('reference');
    let offerId = 0;
    let addOnId = 0;
    const addOnArrays = rootState?.cart?.offers?.filter(offer => offer.addOns !== undefined);
    const selectedAddOnArray = addOnArrays?.map(arr =>
      arr?.addOns?.filter(ele => {
        if (ele.catalogCode === catalogCode) {
          offerId = arr.id;
        }
        return ele.catalogCode === catalogCode;
      })
    );
    const targetArray = selectedAddOnArray?.filter(ele => ele.length > 0)[0];
    addOnId = targetArray[0].id;

    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      cartType: getCookie('cart_Type'),
    };
    const data = await removeAddOns({ graphql, variables });
    setOfferSelected(null);
    setShowLoader(' ');
    dispatch({ type: 'SET_CART', payload: data });
    if (data) {
      const cartOfferId = await rootState.cart?.offers?.filter(
        offer => offer.baseOffer?.serviceGroup === MOBILE
      )[0]?.id;
      const cartEquipmentId = JSON.stringify(rootState?.cart?.offers[0]?.equipments[0]?.id);
      const result = await removeEquipment({
        graphql,
        variables: {
          reference: getCookie('reference'),
          cartType: getCookie('cart_Type'),
          offerId: JSON.stringify(cartOfferId),
          equipmentId: cartEquipmentId,
        },
      });
      if (result != null) {
        dispatch({ type: 'SET_CART', payload: result?.removeEquipment });
      } else {
        console.error('error removing equipment cart item');
      }
    }
  } catch (err) {
    console.error(err);
    setOnLoadError(true);
    setShowLoader(false);
    setOpenError(true);
    setErrorModalOccurence(errorModalOccurence + 1);
    errorModal.enable();
    openAPIFailureModal.enable();
    return err;
  }
};

export const onLoadPrepayAddons = async (rootState, setOfferSelected, dispatch, graphql) => {
  if (getCookie('reference')) {
    if (!rootState?.cart) {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: getCookie('reference') },
      });
      dispatch({ type: 'SET_CART', payload: cart });
      displayCart({
        dispatch,
        nextMethod: null,
      });
    }
  }
  const addOnArrays = rootState?.cart?.offers?.filter(
    offer => offer.addOns !== undefined && offer.baseOffer?.serviceGroup === MOBILE
  );
  const selectedAddOnArray = addOnArrays?.map(arr => arr?.addOns);
  const addons = selectedAddOnArray?.flat();
  const catalogCode = addons?.find(ele => ele.catalogCode)?.catalogCode;
  setOfferSelected(catalogCode);
};
